import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSchedulersSelected, selectSchedulersTotal, selectSelectedSection } from 'store/Schedule/selectors';
import Button from 'shared/ui/Button';
import { useIntl } from 'react-intl';
import { Wrapper, Trash } from './styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { openModal } from 'store/modals/actions';
import { MODAL_SCHEDULE_DELETE } from 'store/modals/modals';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_SCHEDULER, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const Delete = () => {
  const [showWarning, setShowWarning] = useState(false);
  const section = useSelector(selectSelectedSection);
  const schedulersCount = useSelector((state) => selectSchedulersTotal(state, section));
  const hasSchedulers = schedulersCount > 0;
  const dispatch = useDispatch();
  const intl = useIntl();
  const schedulersSelected = useSelector(selectSchedulersSelected);
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'scheduler' });
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_SCHEDULER, PERMISSION_TYPES.DELETE));

  const handleClick = () => {
    if (hasSchedulers && allowedByRole) {
      if ((schedulersSelected?.length > 0)) {
        dispatch(openModal(MODAL_SCHEDULE_DELETE));
      } else setShowWarning(true);
    }
  };

  const onCloseWarning = () => setShowWarning(false);

  return (
    <Wrapper>
      <Button variant="ghost" title="Delete" ariaLabel="Delete" onClick={ handleClick } startIcon={ <Trash /> } disabled={ !allowedByRole } />
      {showWarning && <ModalWarning title={ intl.formatMessage({ id: 'schedule.delete.title' }) } onCloseCallback={ onCloseWarning } description={ message } />}
    </Wrapper>
  );
};

export default Delete;
